




import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';
import { logEvent } from '../utils/analytics/GoogleAnalytics.js';
//import { logEvent } from '../utils/analytics/trackEvent.js';
import { askAhaMomentAI } from '../api/askAhaMomentAI.js';
import { getAuth } from 'firebase/auth';
import { trackEvent } from '../utils/analytics/trackEvent.js';

const MarketMovesDecoderAILanding = () => {
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const chatEndRef = useRef(null);
  const auth = getAuth();

  const suggestions = [
    'What does a high U.S. unemployment rate mean for the USD',
    'How does India’s inflation compare to the UK’s ?',
    'Why EUR/USD currency pair is affected by ECB press conference?',
  ];

  const handleAskAI = async () => {
  if (!input.trim()) return;

  setLoading(true);

  const chatSessionId = uuidv4();
  const user = auth.currentUser;
  const userId = user?.uid || 'anonymous';
  const usermessage = input.trim();

  logEvent('marketmovesdecoder_aha_ask_ai_click', {
    event_category: 'Marketmovesdecoder_Aha_Moment',
    event_label: usermessage,
    value: 1,
  });

  // ✅ Navigate immediately
  navigate(`/learn/space/${chatSessionId}`, {
    state: { question: usermessage },
  });

  // 🔁 Background AI fetch (don’t block navigation)
  askAhaMomentAI({
    userId,
    chatsessionid: chatSessionId,
    usermessage,
    messageCount: 0,
  })
    .then((airesponse) => {
      sessionStorage.setItem(`ahaResponse-${chatSessionId}`, JSON.stringify({
        question: usermessage,
        airesponse,
      }));
    })
    .catch((err) => {
      console.warn('AI fetch failed after navigation:', err);
    });

  // Optionally stop the loading state (or skip it since page is changing)
  setLoading(false);
};

  

  

  return (
    <>
      <Header />
      <div style={{ background: '#232830', color: '#fff', minHeight: '100vh', paddingTop: '80px', fontFamily: 'Nunito Sans, sans-serif' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto', padding: '0 1rem' }}>
          <h1 style={{ fontSize: '2.4rem', fontWeight: '800', textAlign: 'center', color: '#ffffff' }}>📈✨Forex -  Market Moves Decoder </h1>
          <p style={{ fontSize: '1.8rem', textAlign: 'center', marginBottom: '2rem', color: '#ffffff' }}>
          – Understand What Moves Currencies?
          </p>

          <div style={{ position: 'relative', marginBottom: '1rem' }}>
          <textarea
  value={input}
  onChange={(e) => setInput(e.target.value)}
  placeholder="e.g. Why economic reports have an impact on the financial markets ?"
  rows={5}
  style={{
    width: '100%',
    padding: '1rem',
    borderRadius: '16px',
    fontSize: '1.1rem',
    border: '1px solid #ccc',
    outline: 'none',
    resize: 'vertical',
    fontFamily: 'Nunito Sans, sans-serif',
    color: '#fff',
    backgroundColor: '#2C2F36',
  }}
/>
            <button
              onClick={handleAskAI}
              style={{
                position: 'absolute',
                bottom: '12px',
                right: '12px',
                padding: '0.75rem 1.25rem',
                fontWeight: '700',
                fontSize: '1rem',
                backgroundColor: '#FF7C24',
                color: '#fff',
                border: 'none',
                borderRadius: '10px',
                cursor: 'pointer',
              }}
            >
                {loading ? 'Thinking...' : 'Ask AI'}
            </button>
          </div>

          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '2rem' }}>
            {suggestions.map((text, index) => (
              <button
                key={index}
                onClick={() => {
                  setInput(text);
                  trackEvent('marketmovesdecoder_suggestion_click', {
                    event_category: 'Aha Moment marketmovesdecoder',
                    event_label: text,
                    value: 1,
                  });
                }}
                style={{
                  padding: '0.6rem 1rem',
                  backgroundColor: '#fff',
                  color: '#232830',
                  borderRadius: '12px',
                  border: 'none',
                  fontWeight: '600',
                  cursor: 'pointer',
                  fontFamily: 'Nunito Sans, sans-serif',
                }}
              >
                {text}
              </button>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MarketMovesDecoderAILanding;

